/**
 * Ecwid entity class
 */

/**
 * EcwidFactory
 * returns Ecwid entity class
 *
 * @class EcwidFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Ecwid} class
 *
 * @ngdoc factory
 * @name mwApp.factory:EcwidFactory
 */
/* @ngInject */
export default function EcwidFactory ($http, Entity, onOffMixin) {
  /* === Ecwid class === */

  /**
   * Ecwid model
   *
   * @class Ecwid
   * @classdesc Ecwid model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.m2mMixin
   * @mixes models.onOffMixin
   * @mixes models.FileUploadMixin
   * @return {models.Ecwid} Ecwid entity
   */
  function Ecwid () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Ecwid.prototype = Object.create(Entity.prototype)
  Ecwid.prototype.constructor = Ecwid

  /* === Ecwid instance methods & fields === */

  Object.assign(Ecwid.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Ecwid#
     * @type {Object}
     */
    _fields: {
      id: Number,
      networkId: Number,
      token: String,
      storeId: String,
      enabled: false,
      type: 'ECWID',
      currency: 'Currency',
      createdTime: String,
      updatedTime: String,
      createdBy: String,
      updatedBy: String
    },

    /**
     * url template
     *
     * @memberof models.Ecwid#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/ecommerce-provider/{{::id}}'
  }, onOffMixin)

  /* === Ecwid static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Ecwid, Entity)
  Ecwid._name = 'Ecwid'
  Ecwid.init()

  // permissions
  // Ecwid.access = {}

  // extra
  // Ecwid.extra = {}

  return Ecwid
}
